import gql from 'graphql-tag'

export default gql`
query listBillsStatistics($cashRegisterIds: [ID], $numbers: [Int]) {
	cashAssist {
		listBills(filterAndOp: {cashRegisterIds: $cashRegisterIds, numbers: $numbers }) {
			items {
				total
				items {
					amount
					price
					total
					discountPercent
					inCafe
					codeMWSt
					flag
					mul1
					product {
						name
						code
					}
				}
			}
		}
	}
}
`
